import { Link } from "wouter";
import { FaInstagram, FaPinterestP, FaLinkedinIn } from "react-icons/fa";
import { SiSubstack } from "react-icons/si";
import { BrandLockup } from "@/components/brand-lockup";

const SOCIALS = [
  { label: "Instagram", href: "https://instagram.com/unfoldwin", Icon: FaInstagram },
  { label: "Pinterest", href: "https://pinterest.com/unfoldwin", Icon: FaPinterestP },
  { label: "LinkedIn", href: "https://linkedin.com/company/unfoldwin", Icon: FaLinkedinIn },
  { label: "Substack", href: "https://unfoldwin.substack.com", Icon: SiSubstack },
];

const PRODUCT_LINKS = [
  { label: "Library", href: "/library" },
  { label: "Unfoldings", href: "/unfoldings" },
  { label: "Pricing", href: "/pricing" },
  { label: "New Unfolding", href: "/app" },
];

const COMPANY_LINKS = [
  { label: "Contact", href: "/contact" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full border-t border-border/40 bg-background/60 mt-auto">
      <div className="w-full px-6 md:px-8 lg:px-12 xl:px-16 py-12">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-5">
            <Link href="/" className="inline-flex items-center">
              <BrandLockup />
            </Link>
            <p className="text-sm text-muted-foreground mt-4 max-w-md leading-relaxed">
              Where consumption becomes momentum. Turn what you read, watch, and feel into real change.
            </p>
            <div className="flex items-center gap-2 mt-5">
              {SOCIALS.map(({ label, href, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-full flex items-center justify-center bg-muted/60 text-muted-foreground hover:bg-primary/10 hover:text-primary transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div className="md:col-span-3">
            <h3 className="text-xs font-bold uppercase tracking-widest text-foreground mb-4">
              Product
            </h3>
            <ul className="space-y-2.5">
              {PRODUCT_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-4">
            <h3 className="text-xs font-bold uppercase tracking-widest text-foreground mb-4">
              Company
            </h3>
            <ul className="space-y-2.5">
              {COMPANY_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-border/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            © {year} UnfoldWin.com. All rights reserved. A product of{" "}
            <a
              href="https://day0labs.io/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-foreground/70 underline underline-offset-2 transition-colors hover:text-foreground"
            >
              Day0 Labs
            </a>
            .
          </p>
          <p className="text-xs text-muted-foreground">
            Made with care for reflective minds.
          </p>
        </div>
      </div>
    </footer>
  );
}
